import { render, staticRenderFns } from "./InputKendaraan.vue?vue&type=template&id=c2eb1106&"
import script from "./InputKendaraan.vue?vue&type=script&lang=js&"
export * from "./InputKendaraan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports